import { isNumber } from '@monash/portal-frontend-common';

export const getNumberOfAllowedAttempts = (allowedAttempts) => {
  if (!allowedAttempts || !isNumber(allowedAttempts) || allowedAttempts <= 0) {
    return;
  }
  return allowedAttempts;
};
